import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  FaShieldAlt, 
  FaUserTie, 
  FaMicrochip, 
  FaLock,
  FaCheckCircle,
  FaArrowRight,
  FaStar,
  FaClock,
  FaChartLine,
  FaUsers,
  FaTrophy,
  FaHandshake,
  FaMedal,
  FaEye,
  FaBullseye,
  FaHeart,
  FaGlobe,
  FaBuilding,
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp,
  FaGem,
  FaRocket,
  FaAward,
  FaUserCheck,
  FaCalendarAlt
} from "react-icons/fa";
import "../styles/AboutUs.css";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";

// Import hero images for fading slider
import heroBg1 from "../assets/c1.png";
import heroBg2 from "../assets/a2.png";
import heroBg3 from "../assets/a6.png";
import teamImage from "../assets/n4.png";
import officeImage from "../assets/dit3.png";
import WhyChooseUs from "../component/WhyChooseUs";

const AboutUs = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [counters, setCounters] = useState({
    cases: 0,
    success: 0,
    experience: 0,
    detectives: 0
  });

  const heroSlides = [
    { image: heroBg1, title: "Excellence in Investigation", subtitle: "15+ Years of Trust" },
    { image: heroBg2, title: "Truth Behind Every Mystery", subtitle: "5000+ Cases Solved" },
    { image: heroBg3, title: "Your Trusted Partner", subtitle: "98% Success Rate" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
        setIsTransitioning(false);
      }, 800);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCounters({
        cases: 5000,
        success: 98,
        experience: 15,
        detectives: 50
      });
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const stats = [
    { 
      number: counters.cases, 
      suffix: "+", 
      label: "Cases Solved", 
      icon: <FaChartLine />, 
      color: "#3b82f6",
      delay: 0.1
    },
    { 
      number: counters.success, 
      suffix: "%", 
      label: "Success Rate", 
      icon: <FaStar />, 
      color: "#f59e0b",
      delay: 0.2
    },
    { 
      number: counters.experience, 
      suffix: "+", 
      label: "Years Experience", 
      icon: <FaClock />, 
      color: "#06d881",
      delay: 0.3
    },
    { 
      number: counters.detectives, 
      suffix: "+", 
      label: "Expert Detectives", 
      icon: <FaUsers />, 
      color: "#ef4444",
      delay: 0.4
    },
  ];

  const services = [
    { icon: <FaShieldAlt />, title: "Personal Investigation", count: "5000+", color: "#3b82f6" },
    { icon: <FaBuilding />, title: "Corporate Cases", count: "2000+", color: "#06d881" },
    { icon: <FaGlobe />, title: "NRI Services", count: "1000+", color: "#f59e0b" },
    { icon: <FaMicrochip />, title: "Cyber Forensics", count: "800+", color: "#ef4444" },
  ];

  const teamMembers = [
    { name: "Jitender Dubey", role: "Founder & CEO", experience: "10+ years", image: teamImage, color: "#3b82f6" },
    { name: "Dharmender Dubey", role: "Director of Operations", experience: "7+ years", image: teamImage, color: "#06d881" },
  ];

  const timeline = [
    { year: "2016", title: "Foundation", description: "Indian-Detective Agency established", icon: <FaCalendarAlt /> },
    { year: "2018", title: "Expansion", description: "Opened 5 new offices across India", icon: <FaGlobe /> },
    { year: "2020", title: "Digital Era", description: "Launched cyber investigation services", icon: <FaMicrochip /> },
    { year: "2022", title: "Milestone", description: "1000+ successful cases completed", icon: <FaAward /> },
    { year: "2024", title: "Excellence", description: "5000+ cases & 98% success rate", icon: <FaRocket /> },
  ];

  return (
    <>
      <Navbar />
      <div className="about-us-premium">
        {/* Animated Background */}
        <div className="premium-bg">
          <div className="gradient-orb-1"></div>
          <div className="gradient-orb-2"></div>
          <div className="gradient-orb-3"></div>
          <div className="noise-overlay"></div>
        </div>

        {/* Hero Section with Fading Background */}
        <section className="premium-hero">
          {/* Fading Background Images */}
          <div className="hero-fading-bg">
            {heroSlides.map((slide, index) => (
              <div
                key={index}
                className={`hero-fading-slide ${index === currentSlide ? "active" : ""}`}
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="hero-slide-overlay"></div>
              </div>
            ))}
            <div className="hero-gradient-overlay"></div>
          </div>

          {/* Hero Content */}
          <div className="hero-content-wrapper">
            <div className="hero-badge">
              <FaMedal />
              <span>Trusted Since 2016</span>
            </div>
            <h1 className="hero-title">
              About <span className="title-glow">Indian-Detective Agency</span>
            </h1>
            <p className="hero-subtitle">
              India's most trusted detective agency, delivering truth with integrity, 
              confidentiality, and professionalism for over 15 years.
            </p>
            <div className="hero-stats-grid">
              {stats.map((stat, index) => (
                <div key={index} className="hero-stat-premium" style={{ animationDelay: `${stat.delay}s` }}>
                  <div className="stat-icon" style={{ color: stat.color }}>{stat.icon}</div>
                  <div className="stat-content">
                    <div className="stat-number">
                      {stat.number.toLocaleString()}{stat.suffix}
                    </div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Slide Dots */}
          <div className="hero-slider-dots">
            {heroSlides.map((_, index) => (
              <button
                key={index}
                className={`slider-dot ${index === currentSlide ? "active" : ""}`}
                onClick={() => {
                  setIsTransitioning(true);
                  setTimeout(() => {
                    setCurrentSlide(index);
                    setIsTransitioning(false);
                  }, 500);
                }}
              />
            ))}
          </div>
        </section>

        {/* About Content Grid */}
        <section className="premium-about-grid">
          <div className="container-premium">
            <div className="about-two-column">
              <div className="about-text-content">
                <div className="section-badge-premium">Who We Are</div>
                <h2>India's Most Trusted <span className="gradient-premium">Investigation Partner</span></h2>
                <p className="about-description">
                  <strong>Indian-Detective Agency</strong> was founded in 2016 with a vision to revolutionize 
                  the investigation industry in India. Today, we stand as one of the most trusted names 
                  in detective services, having successfully solved over 5000 cases with a 98% success rate.
                </p>
                <p className="about-description">
                  Our team of 50+ licensed professionals combines traditional detective skills with 
                  cutting-edge technology to deliver results that stand up in court. We operate across 
                  25+ cities in India, providing round-the-clock support to our clients.
                </p>
                <div className="feature-list">
                  <div className="feature-item">
                    <FaCheckCircle />
                    <span>Government Licensed Agency</span>
                  </div>
                  <div className="feature-item">
                    <FaCheckCircle />
                    <span>ISO 9001:2015 Certified</span>
                  </div>
                  <div className="feature-item">
                    <FaCheckCircle />
                    <span>Court-Admissible Evidence</span>
                  </div>
                  <div className="feature-item">
                    <FaCheckCircle />
                    <span>100% Confidentiality Guaranteed</span>
                  </div>
                </div>
                <Link to="/contact-us" className="premium-cta-btn">
                  Get Free Consultation <FaArrowRight />
                </Link>
              </div>
              <div className="about-image-content">
                <div className="image-card">
                  <img src={officeImage} alt="Indian-Detective Agency" />
                  <div className="floating-card experience">
                    <FaAward />
                    <div>
                      <strong>15+ Years</strong>
                      <span>Of Excellence</span>
                    </div>
                  </div>
                  <div className="floating-card rating">
                    <FaStar />
                    <div>
                      <strong>4.9/5</strong>
                      <span>Client Rating</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
<WhyChooseUs/>
        {/* Mission Vision Section */}
        <section className="premium-mv">
          <div className="container-premium">
            <div className="mv-cards">
              <div className="mv-card mission">
                <div className="mv-icon">🎯</div>
                <h3>Our Mission</h3>
                <p>To deliver truth with integrity using cutting-edge investigative techniques while maintaining the highest standards of confidentiality and professionalism.</p>
                <div className="mv-stats">
                  <div className="mv-stat">
                    <span>5000+</span>
                    <label>Cases Solved</label>
                  </div>
                  <div className="mv-stat">
                    <span>98%</span>
                    <label>Success Rate</label>
                  </div>
                </div>
              </div>
              <div className="mv-card vision">
                <div className="mv-icon">👁️</div>
                <h3>Our Vision</h3>
                <p>To become India's most trusted and technologically advanced detective agency, setting new benchmarks in investigative excellence.</p>
                <div className="mv-stats">
                  <div className="mv-stat">
                    <span>50+</span>
                    <label>Experts</label>
                  </div>
                  <div className="mv-stat">
                    <span>25+</span>
                    <label>Cities</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Stats */}
        <section className="premium-services-stats">
          <div className="container-premium">
            <div className="stats-grid-premium">
              {services.map((service, index) => (
                <div key={index} className="stat-card-premium" style={{ borderBottomColor: service.color }}>
                  <div className="stat-card-icon" style={{ color: service.color }}>{service.icon}</div>
                  <h3>{service.title}</h3>
                  <div className="stat-card-number">{service.count}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Timeline Section */}
        <section className="premium-timeline">
          <div className="container-premium">
            <div className="section-header-premium">
              <div className="header-badge">Our Journey</div>
              <h2>Key <span className="gradient-premium">Milestones</span></h2>
            </div>
            <div className="timeline-premium">
              {timeline.map((item, index) => (
                <div key={index} className="timeline-node">
                  <div className="timeline-icon" style={{ backgroundColor: "#3b82f6" }}>
                    {item.icon}
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-year">{item.year}</div>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="premium-values">
          <div className="container-premium">
            <div className="section-header-premium">
              <div className="header-badge">Core Values</div>
              <h2>What Drives <span className="gradient-premium">Us</span></h2>
            </div>
            <div className="values-grid-premium">
              <div className="value-card-premium">
                <div className="value-icon">🔒</div>
                <h3>Confidentiality</h3>
                <p>Your privacy is our utmost priority with strict non-disclosure agreements.</p>
              </div>
              <div className="value-card-premium">
                <div className="value-icon">⚖️</div>
                <h3>Integrity</h3>
                <p>We conduct every investigation with honesty and ethical standards.</p>
              </div>
              <div className="value-card-premium">
                <div className="value-icon">🏆</div>
                <h3>Excellence</h3>
                <p>We strive for perfection in every case we handle.</p>
              </div>
              <div className="value-card-premium">
                <div className="value-icon">🤝</div>
                <h3>Professionalism</h3>
                <p>Maintaining the highest professional standards always.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="premium-team">
          <div className="container-premium">
            <div className="section-header-premium">
              <div className="header-badge">Leadership</div>
              <h2>Meet Our <span className="gradient-premium">Experts</span></h2>
            </div>
            <div className="team-grid-premium">
              {teamMembers.map((member, index) => (
                <div key={index} className="team-card-premium">
                  <div className="team-avatar" style={{ backgroundColor: `${member.color}15`, color: member.color }}>
                    <FaUserTie />
                  </div>
                  <h3>{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                  <span className="team-exp">{member.experience}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Certifications */}
        <section className="premium-certs">
          <div className="container-premium">
            <div className="certs-scroll">
              <div className="cert-item">
                <FaGem />
                <span>ISO 9001:2015 Certified</span>
              </div>
              <div className="cert-item">
                <FaShieldAlt />
                <span>Government Licensed</span>
              </div>
              <div className="cert-item">
                <FaLock />
                <span>PCI DSS Compliant</span>
              </div>
              <div className="cert-item">
                <FaHandshake />
                <span>APDI Member</span>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="premium-cta">
          <div className="container-premium">
            <div className="cta-wrapper">
              <h2>Ready to Work With India's Most Trusted Detective Agency?</h2>
              <p>Get a free, no-obligation consultation with our expert team today.</p>
              <div className="cta-buttons-premium">
                <a href="tel:+917428203483" className="cta-premium-btn primary">
                  <FaPhoneAlt /> Call Now: +91 7428203483
                </a>
                <a href="https://wa.me/917428203483" className="cta-premium-btn whatsapp" target="_blank" rel="noopener noreferrer">
                  <FaWhatsapp /> WhatsApp Us
                </a>
                <Link to="/contact" className="cta-premium-btn secondary">
                  <FaEnvelope /> Contact Us
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default AboutUs;